export default __webpack_public_path__ + "static/media/NewList_grid.e48602aa.png";